<template>
  <div>
    <div v-if="type == 1" class="m-title flex">
      <div class="left1 flex-sub">{{ title }}</div>
      <div @click="linkTo" class="more">更多 ></div>
    </div>
    <div v-else class="m-title flex">
      <div class="left2">
        {{ title }}
        <img class="sjx" src="/static/image/index/title_sjx.png" alt="" style="" />
      </div>
      <div @click="linkTo" class="more mr20">更多 ></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    title: {},
    type: {
      default: 1,
    },
    linkUrl: {},
  },
  components: {},
  data() {
    return {}
  },
  created() {},
  computed: {
    // ...mapGetters(['winScroll']),
  },
  watch: {},
  mounted() {},

  methods: {
    linkTo() {
      this.$router.push({ path: this.linkUrl })
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/barTitle.vue